<template>
  <v-container class="container--fluid" id="application-view">
    <BackToPreviousPageBar
      back-route-text="Back to Applications List"
      back-route-name="applications-list"
      :show-loading="isLoading"
    />

    <v-card v-if="applicationData">
      <v-card-title>Application Details</v-card-title>
      <v-divider />
      <v-card-text class="py-6">
        <v-row>
          <v-col cols="12" md="4" class="py-0">
            <v-list class="pa-0">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Name</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ applicationData.name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Business Email</v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="mr-1">{{ applicationData.email }}</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="copyValue(applicationData.email)"
                          small
                        >
                          {{ icons.mdiContentCopy }}
                        </v-icon>
                      </template>
                      <span>Copy</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Phone Number</v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="mr-1">{{ applicationData.number }}</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          @click="copyValue(applicationData.number)"
                          small
                        >
                          {{ icons.mdiContentCopy }}
                        </v-icon>
                      </template>
                      <span>Copy</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Website URL</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    <a :href="applicationData.website" target="_blank">{{ applicationData.website }}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="4" class="py-0">
            <v-list class="pa-0">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Company Name</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ applicationData.companyName }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Company Address</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">{{ applicationData.companyAddress }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Preferred Method of Communication</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">{{ Array.isArray(applicationData.communication) ? applicationData.communication.join(', ') : '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Preferred Messaging App</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">{{ applicationData.messenger || '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>

          <v-col cols="12" md="4" class="py-0">
            <v-list class="pa-0">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Username</v-list-item-title>
                  <v-list-item-subtitle>{{ applicationData.account || '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>How did you hear about us?</v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">{{ applicationData.source || '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Additional Notes</v-list-item-title>
                  <v-list-item-subtitle>{{ applicationData.notes || '-' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mdiContentCopy } from '@mdi/js';
import store from '@/store';
import router from '@/router';
import { ref } from '@vue/composition-api';
import BackToPreviousPageBar
  from '@core/layouts/components/back-to-previous-page-bar/BackToPreviousPageBar.vue';
import { copyValue } from '@core/utils';

export default {
  components: { BackToPreviousPageBar },
  setup() {
    const applicationData = ref(null);
    const isLoading = ref(true);

    store
      .dispatch('application/fetchApplicationById', { id: router.currentRoute.params.id })
      .then(response => {
        applicationData.value = response.data;
      })
      .catch(error => {
        if (error.response.status === 404) {
          applicationData.value = undefined;
        }
      })
      .finally(() => isLoading.value = false);

    return {
      applicationData,
      isLoading,
      copyValue,
      icons: {
        mdiContentCopy,
      },
    };
  },
};
</script>
